import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useDebounce } from '../hooks';
import { useField } from '@unform/core';
import { VerbaService } from '../services/api/rh/verbas/VerbaService';


type TAutoCompleteOption = {
  label: string;
  idverbas: string;
}

interface IAutoCompleteProps {
  isExternalLoading?: boolean;
  idverbas?: (novoTextoselect: string) => void; 
  descricao?: (novoTextoselect: string | undefined) => void;
}
export const AutoCompleteVerbas: React.FC<IAutoCompleteProps> = ({ isExternalLoading = false, idverbas }) => {
  const { fieldName, registerField, defaultValue, error, clearError } = useField('idverbas');
  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<string | undefined>(defaultValue);

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');

  useEffect(() => {
    registerField({  
      name: fieldName,
      getValue: () => selectedId,
      setValue: (_, newSelectedId) => setSelectedId(newSelectedId),
    });
  }, [registerField, fieldName, selectedId]);
   
  useEffect(() => {
    setIsLoading(true);

    debounce(() => {
      VerbaService.getAllList(selectedId, busca)
        .then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {
            // alert(result.message);
          } else {
            setOpcoes(result.data.map(verbas => ({ idverbas: verbas.idverbas, label: verbas.descricao })));
          }
        });
    });
  }, [busca, selectedId]);

  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.idverbas === selectedId);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);


  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'
      disablePortal
      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      onInputChange={(_, newValue) => setBusca(newValue)}
      onChange={(_, newValue) => { setSelectedId(newValue?.idverbas); idverbas?.(newValue?.idverbas ?? ''); setBusca(''); clearError(); }}
      popupIcon={(isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          label="Verbas"
          error={!!error}
          helperText={error}
        />
      )}
    />
  );
};